var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    [
      _c("el-row", [
        _c("span", { staticStyle: { "font-weight": "500" } }, [
          _vm._v(_vm._s(_vm.$t("dataset.detail"))),
        ]),
      ]),
      _c(
        "el-col",
        [
          _vm.tabStatus
            ? _c(
                "el-tabs",
                {
                  staticClass: "info-tab",
                  model: {
                    value: _vm.tabActive,
                    callback: function ($$v) {
                      _vm.tabActive = $$v
                    },
                    expression: "tabActive",
                  },
                },
                [
                  _vm.type === "chart" && _vm.detail.chart
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("chart.datalist"),
                            name: "chart",
                          },
                        },
                        [
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("commons.name"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.chart.name)),
                            ]),
                          ]),
                          _c(
                            "el-col",
                            { staticClass: "info-item" },
                            [
                              _c("p", { staticClass: "info-title" }, [
                                _vm._v(_vm._s(_vm.$t("chart.chart_type"))),
                              ]),
                              _vm.detail.chart.type
                                ? _c("svg-icon", {
                                    attrs: {
                                      "icon-class": _vm.detail.chart.type,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("chart.title"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.chart.title || "-")),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("dataset.create_by"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.chart.createBy)),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("dataset.create_time"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("timestampFormatDate")(
                                    _vm.detail.chart.createTime
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.detail.table
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("dataset.datalist"),
                            name: "table",
                          },
                        },
                        [
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("commons.name"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.table.name)),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("dataset.type"))),
                            ]),
                            _vm.detail.table.type === "db"
                              ? _c("p", { staticClass: "info-content" }, [
                                  _vm._v(_vm._s(_vm.$t("dataset.db_data"))),
                                ])
                              : _vm._e(),
                            _vm.detail.table.type === "sql"
                              ? _c("p", { staticClass: "info-content" }, [
                                  _vm._v(_vm._s(_vm.$t("dataset.sql_data"))),
                                ])
                              : _vm._e(),
                            _vm.detail.table.type === "excel"
                              ? _c("p", { staticClass: "info-content" }, [
                                  _vm._v(_vm._s(_vm.$t("dataset.excel_data"))),
                                ])
                              : _vm._e(),
                            _vm.detail.table.type === "custom"
                              ? _c("p", { staticClass: "info-content" }, [
                                  _vm._v(_vm._s(_vm.$t("dataset.custom_data"))),
                                ])
                              : _vm._e(),
                            _vm.detail.table.type === "union"
                              ? _c("p", { staticClass: "info-content" }, [
                                  _vm._v(_vm._s(_vm.$t("dataset.union_data"))),
                                ])
                              : _vm._e(),
                          ]),
                          _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.detail.table.type === "db",
                                  expression: "detail.table.type === 'db'",
                                },
                              ],
                              staticClass: "info-item",
                            },
                            [
                              _c("p", { staticClass: "info-title" }, [
                                _vm._v(_vm._s(_vm.$t("dataset.table"))),
                              ]),
                              _c("p", { staticClass: "info-content" }, [
                                _vm._v(_vm._s(_vm.info.table)),
                              ]),
                            ]
                          ),
                          _vm.detail.table.type === "db" ||
                          _vm.detail.table.type === "sql"
                            ? _c("el-col", { staticClass: "info-item" }, [
                                _c("p", { staticClass: "info-title" }, [
                                  _vm._v(_vm._s(_vm.$t("dataset.mode"))),
                                ]),
                                _vm.detail.table.mode === 0
                                  ? _c("p", { staticClass: "info-content" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("dataset.direct_connect"))
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.detail.table.mode === 1
                                  ? _c("p", { staticClass: "info-content" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("dataset.sync_data"))
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("dataset.create_by"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.table.createBy)),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("dataset.create_time"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("timestampFormatDate")(
                                    _vm.detail.table.createTime
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.detail.datasource
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("datasource.datasource"),
                            name: "datasource",
                          },
                        },
                        [
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("commons.name"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.datasource.name)),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("commons.description"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.datasource.desc || "-")),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("datasource.type"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(_vm._s(_vm.detail.datasource.type)),
                            ]),
                          ]),
                          _c("el-col", { staticClass: "info-item" }, [
                            _c("p", { staticClass: "info-title" }, [
                              _vm._v(_vm._s(_vm.$t("dataset.create_time"))),
                            ]),
                            _c("p", { staticClass: "info-content" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("timestampFormatDate")(
                                    _vm.detail.datasource.createTime
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }